
/**
 * 💳 STRIPE CONFIGURATION CENTER
 * 
 * TO SWITCH TO LIVE MODE:
 * 1. Change 'MODE' to 'live'.
 * 2. Ensure you have updated the 'STRIPE_SECRET_KEY' in your Supabase Edge Function secrets.
 */

const MODE: 'test' | 'live' = 'live'; 

const CONFIG = {
  test: {
    PUBLISHABLE_KEY: 'pk_test_51SrTWL2L9HyYOs3UuXTJnHJ27683SaiwbIEhKvG7QuJ1Q5ETUzpMZaPR80zyOzYNKht0gR4FvoDX7Lh40J2hU4eQ00h7rRqgBW',
    PRICES: {
      plus: 'price_1SrUuH2L9HyYOs3U93K6JPOP',
      pro: 'price_1SrUul2L9HyYOs3UFPmudILV',
      god: 'price_1SrUvH2L9HyYOs3U1b5FAQnf', 
      refill: 'price_1SrjJL2L9HyYOs3U8LiiVUYx'
    }
  },
  live: {
    PUBLISHABLE_KEY: 'pk_live_51SrTWL2L9HyYOs3UOSgmsTK9vJBnsprB0WIBufRzTVGgceHxiH3HPqHN4DLZtRPLZht1ZcFEDjfyIOv76OFKFExn00oi4o25jl',
    PRICES: {
      plus: 'price_1SrkAX2L9HyYOs3U4iMM7k0T',
      pro: 'price_1SrkAU2L9HyYOs3Uq0PfgVKL',
      god: 'price_1SrkAR2L9HyYOs3UItcYE1QR',
      refill: 'price_1SrkAM2L9HyYOs3UiqB49DWM'
    }
  }
};

export const STRIPE_CONFIG = CONFIG[MODE];

export const WHITELISTED_EMAILS = [
  'king20@gmail.com',
  'king76@mac.com',
  'paxtonking2017@gmail.com'
];

export const isStripeConfigured = () => 
  STRIPE_CONFIG.PUBLISHABLE_KEY !== 'pk_test_placeholder' && 
  !STRIPE_CONFIG.PUBLISHABLE_KEY.includes('placeholder');
